export const EXPERIMENTS = {
  DOUBLE_OPT_IN_SETTING: 'specs.forms.DoubleOptInSettings',
  TRANSLATE_ECOM_EMAIL: 'specs.forms.TranslateEcomEmail',
  REMOVE_FLEXBOX: 'specs.forms.RemoveFlexbox',
  OVERRIDE_MLA_FIELD_IDS: 'specs.forms.OverrideMLAFieldIds',
  GLOBAL_SUBMIT_SETTINGS_VIEWER: 'specs.forms.GlobalSubmitSettingsViewer',
  SUBMIT_STATUS_MESSAGE_VIEWER: 'specs.forms.SubmitStatusMessageViewer',
  USE_CUSTOM_ERROR_MESSAGES: 'specs.forms.UseCustomErrorMessages'
};
//# sourceMappingURL=experiments.js.map